import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

interface LineBreakTypographyProps {
  text: string;
  variant: "body1" | "body2" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "subtitle1" | "subtitle2";
  sx?: object;
  color?: "primary" | "secondary" | "textPrimary" | "textSecondary" | "error";
  gutterBottom?: boolean;
  asteriskStyle?: {
    fontSize?: string | number;
    color?: string;
  };
}

const LineBreakTypography: React.FC<LineBreakTypographyProps> = ({ 
  text, 
  variant, 
  sx = {}, 
  color,
  gutterBottom = false,
  asteriskStyle = { fontSize: '0.8em', color: 'text.secondary' }
}) => {
  const renderText = () => {
    const lines = text.split('\n');
    let isAsteriskSection = false;
    
    return lines.map((line, index) => {
      if (line.includes('※')) {
        isAsteriskSection = true;
        const [beforeAsterisk, afterAsterisk] = line.split('※');
        return (
          <Typography
            key={index}
            variant={variant}
            color={color}
            sx={{ 
              ...(index > 0 ? { mt: 0.5 } : {})
            }}
          >
            {beforeAsterisk}
            <Typography
              component="span"
              variant={variant}
              color={asteriskStyle.color || color}
              sx={{ fontSize: asteriskStyle.fontSize }}
            >
              ※{afterAsterisk}
            </Typography>
          </Typography>
        );
      }
      
      return (
        <Typography
          key={index}
          variant={variant}
          color={isAsteriskSection ? asteriskStyle.color || color : color}
          sx={{ 
            ...(index > 0 ? { mt: 0.5 } : {}),
            ...(isAsteriskSection ? { fontSize: asteriskStyle.fontSize } : {})
          }}
        >
          {line}
        </Typography>
      );
    });
  };

  return (
    <Box sx={{ 
      ...sx, 
      ...(gutterBottom ? { mb: 2.5 } : {})
    }}>
      {renderText()}
    </Box>
  );
};

export default LineBreakTypography;